import axios from 'axios';

import { headers, salesServiceUrl } from '../../config';

export function getCustomerSites(customerId) {
    return axios.get(`${salesServiceUrl}/sites`, { headers: headers(), params: { customer_id: customerId } });
}
